import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
import UploadFile from "@mui/icons-material/UploadFile";
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  Card,
  CardContent,
  Grid,
  FormControlLabel,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  Autocomplete,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import typography from "assets/theme/base/typography";
export default function VariantsTableData(attributes, combinations, onPriceChange) {
  const [previewImages, setPreviewImages] = useState({});

  // ✅ تحديد الصور الافتراضية من البيانات المبدئية (عند التعديل)
  useEffect(() => {
    const initialPreviews = {};
    combinations.forEach((variant, index) => {
      if (variant.image && typeof variant.image === "string") {
        // ✅ إذا كانت الصورة رابطًا (مثلاً من السيرفر)
        initialPreviews[index] = variant.image;
      } else if (variant.image instanceof File) {
        // ✅ إذا كانت الصورة ملفًا جديدًا
        initialPreviews[index] = URL.createObjectURL(variant.image);
      }
    });
    setPreviewImages(initialPreviews);
  }, [combinations]);

  // ✅ معالجة رفع الصورة
  const handleImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewImages((prev) => ({
        ...prev,
        [index]: url,
      }));
      onPriceChange(index, "image", file); // ✅ إرسال الملف كـ File وليس كـ URL
    }
  };

  return {
    columns: [
      { Header: "السمات", accessor: "attributes", align: "left" },
      { Header: "SKU", accessor: "sku", align: "center" },
      { Header: "سعر المنتج", accessor: "price", align: "center" },
      { Header: "سعر الشراء", accessor: "purchasePrice", align: "center" },
      { Header: "الخصم", accessor: "discount", align: "center" },
      { Header: "الكمية", accessor: "quantity", align: "center" },
      { Header: "الضريبة", accessor: "taxValue", align: "center" },
      { Header: "نوع الضريبة", accessor: "taxType", align: "center" },
      { Header: "الأبعاد (سم)", accessor: "dimensions", align: "center" },
      { Header: "الوزن (كجم)", accessor: "weight", align: "center" },
      { Header: "الحالة", accessor: "active", align: "center" },
      { Header: "الصورة", accessor: "image", align: "center" },
    ],
    rows: combinations.map((variant, index) => ({
      attributes: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {variant.combo.map((item, idx) => (
            <span key={idx}>
              {item.value} {/* هنا يجب أن تكون قيمة نصية وليس كائن */}
              {idx < variant.combo.length - 1 ? " | " : ""}
            </span>
          ))}
        </MDTypography>
      ),
      sku: (
        <TextField
          label="sku"
          type="text"
          fullWidth
          value={variant.sku}
          onChange={(e) => onPriceChange(index, "price", e.target.value)}
        />
      ),
      price: (
        <TextField
          label="سعر المنتج"
          type="number"
          fullWidth
          value={variant.price}
          onChange={(e) => onPriceChange(index, "price", e.target.value)}
        />
      ),
      purchasePrice: (
        <TextField
          label="سعر الشراء"
          type="number"
          fullWidth
          value={variant.purchasePrice || "0.0"}
          onChange={(e) => onPriceChange(index, "purchasePrice", e.target.value)}
        />
      ),
      discount: (
        <TextField
          label="الخصم"
          type="number"
          fullWidth
          value={variant.discount || "0.0"}
          onChange={(e) => onPriceChange(index, "discount", e.target.value)}
        />
      ),
      quantity: (
        <TextField
          label="الكمية"
          type="number"
          fullWidth
          value={variant.quantity || "0.0"}
          onChange={(e) => onPriceChange(index, "quantity", e.target.value)}
        />
      ),
      taxValue: (
        <TextField
          label="قيمة الضريبة"
          type="number"
          fullWidth
          value={variant.taxValue || "0.0"}
          onChange={(e) => onPriceChange(index, "taxValue", e.target.value)}
        />
      ),
      taxType: (
        <FormControl fullWidth size="small">
          <Select
            value={variant.taxType || "percentage"}
            onChange={(e) => onPriceChange(index, "taxType", e.target.value)}
          >
            <MenuItem value="percentage">نسبة مئوية</MenuItem>
            <MenuItem value="fixed">قيمة ثابتة</MenuItem>
          </Select>
        </FormControl>
      ),
      dimensions: (
        <Box display="flex" gap={1} justifyContent="center">
          <TextField
            label="الطول"
            type="number"
            size="small"
            value={variant.dimensions?.length || "0.0"}
            onChange={(e) =>
              onPriceChange(index, "dimensions", {
                ...variant.dimensions,
                length: e.target.value,
              })
            }
            sx={{ width: 80 }}
          />
          <TextField
            label="العرض"
            type="number"
            size="small"
            value={variant.dimensions?.width || "0.0"}
            onChange={(e) =>
              onPriceChange(index, "dimensions", {
                ...variant.dimensions,
                width: e.target.value,
              })
            }
            sx={{ width: 80 }}
          />
          <TextField
            label="العمق"
            type="number"
            size="small"
            value={variant.dimensions?.depth || "0.0"}
            onChange={(e) =>
              onPriceChange(index, "dimensions", {
                ...variant.dimensions,
                depth: e.target.value,
              })
            }
            sx={{ width: 80 }}
          />
        </Box>
      ),
      weight: (
        <TextField
          label="الوزن"
          type="number"
          fullWidth
          value={variant.weight || "0.0"}
          onChange={(e) => onPriceChange(index, "weight", e.target.value)}
        />
      ),
      active: (
        <MDTypography variant="caption" color={variant.active ? "success.main" : "error.main"}>
          {variant.active ? "نشط" : "غير نشط"}
        </MDTypography>
      ),
      image: (
        <Box textAlign="center">
          {/* إدخال حقل رفع الصورة */}
          <input
            type="file"
            accept="image/*"
            hidden
            id={`upload-image-${index}`}
            onChange={(e) => handleImageChange(index, e)}
          />
          <label htmlFor={`upload-image-${index}`}>
            <IconButton component="span" color="primary" aria-label="رفع صورة">
              <UploadFile fontSize="small" />
            </IconButton>
          </label>

          {/* عرض الصورة (قديمة أو جديدة) */}

          {previewImages[index] && (
            <Box
              mt={1}
              component="img"
              src={previewImages[index]}
              alt="preview"
              sx={{ width: 40, height: 40, objectFit: "cover", borderRadius: 1 }}
            />
          )}
        </Box>
      ),
    })),
  };
}
